import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getHallListAPI } from "services/apis/funeral";

export const getHallList = createAsyncThunk(
  "hall/GET_HALL",
  async (params, { rejectWithValue }) => {
    try {
      const response = await getHallListAPI(params);
      return response;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const initialState = {
  hallList: [],
  currentHall: {},
  loading: false,
  error: null,
};

const hallSlice = createSlice({
  name: "hall",
  initialState,

  reducers: {
    resetState: (state, action) => {
      const fieldName = action.payload;
      state[fieldName] = initialState[fieldName];
    },
  },

  extraReducers: builder => {
    builder
      .addCase(getHallList.pending, state => {
        state.loading = true;
      })
      .addCase(getHallList.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.errors;
      })
      .addCase(getHallList.fulfilled, (state, action) => {
        state.loading = false;
        state.hallList = action.payload?.hallList || [];
      });
  },
});

export const { resetState } = hallSlice.actions;
const { reducer: hallReducer } = hallSlice;
export default hallReducer;
